export const getSchoolId = () => {
  return JSON.parse(localStorage.getItem("school_decode_token")).schoolId;
};

export const getUserId = () => {
  return JSON.parse(localStorage.getItem("school_decode_token")).id;
};
